export var isSSR = function () { return typeof window === 'undefined'; };
